import axios from "axios"
import useSWR from "swr"

const fetcher = async (url, params) => {
  return await axios.get(url, { params }).then((res) => res.data.data)
}

const useStockAdjustmentRepositories = (params) => {
  const shouldFetch = params?.enabled !== false
  const requestParams = { ...params }
  delete requestParams.enabled

  const { data, error, mutate, isValidating } = useSWR(
    shouldFetch
      ? [`${process.env.REACT_APP_INVENTORY_API_URL}/stock-adjustments`, requestParams]
      : null,
    fetcher
  )

  return {
    data,
    isLoading: shouldFetch && !error && !data,
    error,
    isValidating,
    mutate,
  }
}

export default useStockAdjustmentRepositories
